
const menu = [
  {
    name: "Home",
    path: "/",
    icon: "fas fa-tachometer-alt",
    // modulePermission: modules.dashboard,
  },
];

export default menu;
